import HadithController from './HadithController';

export { HadithController };
